<template>
  <iframe
    src="/legacy/index.html"
    style="width:100%;height:100%;border:none"
  ></iframe>
</template>

<script>
export default {
  name: 'Legacy'
}
</script>
